import React, { useState, useEffect, useRef } from "react";
import TopBar from "./../components/TopBar";
import APIURL from "./../Api";
import { LoaderCircle } from "lucide-react";

const WebView = ({ url, title }) => {
  const student = JSON.parse(localStorage.getItem("student"));
  console.log("Sdasd",student)
  const src = `${APIURL}/new_stu_app/${url}&uid=${student.uid}&pwd=${student.password}&id=${student.id}`;

  const [loading, setLoading] = useState(true);
  const iframeRef = useRef(null);

  // Listen for messages from iframe (Laravel page)
  useEffect(() => {
    const handleMessage = (event) => {
      if (typeof event.data !== "string") return;

      if (event.data === "start-loader") {
        setLoading(true);
      }

      if (event.data === "stop-loader") {
        setLoading(false);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return (
    <>
      {/* Top bar stays on top */}
      <TopBar title={title} />

      {/* Loader covers the iframe area only */}
      {loading && (
        <div
          style={{
            position: "fixed",
            top: "50px", // height of TopBar
            left: 0,
            width: "100%",
            height: "calc(100vh - 122px)",
            backgroundColor: "#ffffff",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999, // stay above iframe
          }}
        >
          <LoaderCircle size={40} style={{ animation: "spin 1s linear infinite" }} />
        </div>
      )}

      {/* Iframe below TopBar */}
      <iframe
        ref={iframeRef}
        src={src}
        onLoad={() => setLoading(false)}
        style={{
          height: "calc(100vh - 122px)",
          width: "100%",
          border: "none",
        }}
        title="WebView Iframe"
        allowFullScreen
      ></iframe>

      {/* Spinner animation */}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </>
  );
};

export default WebView;
